import { render, staticRenderFns } from "./ClmDoc.vue?vue&type=template&id=b449a7a8&"
import script from "./ClmDoc.vue?vue&type=script&lang=js&"
export * from "./ClmDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports